module.exports = __webpack_public_path__ + "img/fa-book.6d3733e.svg";